import { render } from "./index.vue?vue&type=template&id=50cd73fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=50cd73fc&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cd73fc"],['__file',"src/views/customer/chat/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50cd73fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50cd73fc', __exports__)) {
    console.log('reload')
    api.reload('50cd73fc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=50cd73fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('50cd73fc', render)
  })

}


export default __exports__